import React, { useEffect, useState } from 'react';
import './index.css';
import NewFooter from 'ComponentsUpdated/NewFooter';
import Swal from "sweetalert2";
import axios from 'axios';

const feedbackData = [
  {
    id: 1,
    name: "Kaivan Wadia",
    title: "Co-Founder, Coverforce",
    avatar: "https://ucarecdn.com/2e169b3e-377d-4f2e-8a3a-a7e245f649d6/KaivanWadia.svg",
    feedbackText: (
      <>
        GoodLives has consistently introduced <strong>innovative workshops</strong> and <strong>creative activities</strong> that have kept our team engagement not just maintained but growing.
        <br />
        We genuinely look forward to these sessions, as they offer us valuable time to <strong>connect, refresh, and prepare</strong> for the day ahead. The positive impact on our team's morale and productivity is undeniable.
      </>
    )
  },
  {
    id: 2,
    name: "Keerthana Iyer",
    title: "HR, Talview",
    avatar: "https://ucarecdn.com/be69131b-53ca-4a15-910d-9ae04950bad6/Keerthana.svg",
    feedbackText: (
      <>
        We found the training to be <strong>well-organized, relevant, and effectively</strong> delivered.
        <br/>
        The trainers demonstrated <strong>excellent facilitation skills</strong> and created an environment conducive to learning. The program has <strong>added clear value</strong> to our employee development efforts.
      </>
    )
  },
  {
    id: 3,
    name: "Anupama Dudhbhale",
    title: "Assistant Manager, Ideaforge",
    avatar: "https://ucarecdn.com/42528385-8d80-44dd-8452-8f8bdd969d5f/Anupama.svg",
    feedbackText: (
      <>
        The sessions with GoodLives felt <strong>tailored, interactive, and directly relevant</strong> to our team’s challenges.
        <br/>
        Our employees not only showed <strong>higher engagement</strong> but also started applying these learnings at work — which is exactly what we hoped for.
      </>
    )
  },
  {
    id: 4,
    name: "Sakshi Agrawal",
    title: "HR Business Partner, Jiffy.ai",
    avatar: "https://ucarecdn.com/d3c82f26-a435-4819-bcb1-42641977cae4/Sakshi.svg",
    feedbackText: (
      <>
        What impressed me the most was the way the trainers <strong>simplified complex topics.</strong> Our team left with <strong>practical tools and a fresh mindset.</strong>
        <br/>
        It felt less like a workshop and more like a turning point in how we approach <strong>communication and collaboration.</strong>
      </>
    )
  },
];

const partnerLogos = [
  { src: "https://ucarecdn.com/921998ff-976c-4e1d-8855-d46051598080/Group48096500.svg", alt: "Partner 1 - Coverforce" }, // Added more descriptive alt text
  { src: "https://ucarecdn.com/b83073e4-949a-4410-a8a7-77f811bf1d68/image81.svg", alt: "Partner 2 - Tata Steel" },
  { src: "https://ucarecdn.com/38600bf1-4991-4f27-b91d-79e2bae64e69/image80.svg", alt: "Partner 3 - Aditya Birla Capital" },
  { src: "https://ucarecdn.com/7a83ac66-7e44-40e6-a4d4-f30f686ea2ce/image2837.svg", alt: "Partner 4 - Kotak" },
  { src: "https://ucarecdn.com/86973f8a-a14d-4fb6-b1cd-0363787fe89e/image2838.svg", alt: "Partner 5 - PhysicsWallah" },
  { src: "https://ucarecdn.com/a64e4b0a-9062-482b-9eb6-6e22f4b4ec74/image2839.svg", alt: "Partner 6 - Porter" },
  { src: "https://ucarecdn.com/09892c5f-1aa8-461d-9e42-d7c1e1d86809/image2841.svg", alt: "Partner 7 - KreditBee" },
  { src: "https://ucarecdn.com/68db275d-ec7a-45fa-8dd6-38f216b37aa7/image2840.svg", alt: "Partner 8 - Turtlemint" },
  { src: "https://ucarecdn.com/39751e73-844f-4598-8678-a403864cb710/image2842.svg", alt: "Partner 9 - Fibe" }
];

const cardData = [
  `Certified coaches,\nfacilitators, and\nleadership experts`,
  `20+ years of\ncorporate + cross-\nindustry experience`,
  `Specialists in\nbehavioral change,\norganizational\npsychology, DEI, and\ninnovation`,
  `Trained to deliver both\nhigh-energy workshops\nand quiet, reflective\nsessions — tailored to\naudience needs`,
];

const traningCardLogo = [
  { src: "https://ucarecdn.com/29638799-1d52-4c2c-ad3a-0eeffabf9131/Group48096491.svg", alt: "logo 1" },
  { src: "https://ucarecdn.com/49801e3d-797b-4bd5-8478-8e7a978a5e86/Vector.svg", alt: "logo 2" },
  { src: "https://ucarecdn.com/78928b54-3bab-4f2f-8af1-28cdea1ff818/Vector1.svg", alt: "logo 3" },
  { src: "https://ucarecdn.com/8b86723a-b7d1-4fb9-a256-d19c8a04ff8d/Group48096492.svg", alt: "logo 4" },
];

const offers = [
  {
    title: 'Leadership & Management Excellence',
    description:
    'Transform managers into inspiring leaders who drive performance and navigate change confidently',
    items: [
      'The Leadership Training',
      'Lead the Future: Gen Z & Millennial Leadership Playbook',
      'The Influence Accelerator',
      'The Influence Accelerator',
    ],
    imglink:
      'https://ucarecdn.com/01720822-57a0-413e-8878-b491307eac17/Frame.svg',
    bgColor: '#FCF2D8',
  },
  {
    title: 'Diversity, Equity & Inclusion',
    description:
    'Build inclusive cultures where every employee feels valued and can contribute their best work',
    items: [
      'Practicing Inclusion Everyday',
      'Microaggression Spotter: See It, Stop It, Shift It',
      'Bias Busters: Smarter, Fairer Decisions',
      'The Inclusive Onboarding Blueprint',
    ],
    imglink:
      'https://ucarecdn.com/8d63e50c-f2a7-4fc8-8ca4-c60322e1d766/Frame1.svg',
    bgColor: '#E8EBFF',
  },
  {
    title: 'Personal & Interpersonal Effectiveness',
    description: 'Develop skills in resilience, conflict resolution, and communication.',
    items: [
      'The Sales Influence Code',
      'EQ Mastery: The Emotionally Intelligent Workplace',
      'Communicate Like a Pro',
      'Mastering Difficult Conversations',
    ],
    imglink:
      'https://ucarecdn.com/4232f239-f90e-43ff-a270-8ffd0f49c8d4/Frame2.svg',
    bgColor: '#E8FDF2',
  },
  {
    title: 'Productivity, Workflow & Innovation',
    description: 'Master modern tools and strategies to boost focus, manage change, and deliver results',
    items: [
      'Conflict to Collaboration',
      'Psychological Safety Playbook',
      'The Collaboration Code',
      'Art of Delegation for Managers'
    ],
    imglink:
      'https://ucarecdn.com/4d368205-5590-4714-93fa-a26c1332e29a/Frame3.svg',
    bgColor: '#FCF2D8',
  },
  {
    title: 'Specialized Trainings',
    description: 'Targeted programs for sales influence, difficult conversations, and psychological safety',
    items: [
      'Productivity Hacks for High-Performers',
      'The Change Navigator',
      'Managing Hybrid & Remote Teams',
      'AI x You: Amplify Your Impact',
      'Project Power: Mastering the Art of Getting Things Done',
    ],
    imglink:
      'https://ucarecdn.com/568af046-b5fd-458f-a066-0c0dd167bab4/Frame4.svg',
    bgColor: '#E8EBFF',
  },
];

const DemoPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isCorporateDropdownOpen, setIsCorporateDropdownOpen] = useState(false);
  const selectedOffer = offers[selectedIndex];
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [heroEmailError, setHeroEmailError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedIndex(prevIndex => (prevIndex + 1) % offers.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const toggleCorporateDropdown = () => {
    setIsCorporateDropdownOpen(!isCorporateDropdownOpen);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % feedbackData.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      (prevIndex - 1 + feedbackData.length) % feedbackData.length
    );
  };

  const scheduleDemo = async (event, section) => {
    try {
      event.preventDefault(); // Prevent default form submission
  
      let isValid = true;
  
      // Email validation regex
      const regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
      // Reset all error states initially
      setNameError(false);
      setEmailError(false);
      setPhoneError(false);
  
      // Validate based on section
      if (section === "form") {
        // Name
        if (name.trim() === "") {
          setNameError(true);
          isValid = false;
        }
  
        // Phone
        if (phone.trim() === "" || !/^\d{9,11}$/.test(phone.trim())) {
          setPhoneError(true);
          isValid = false;
        }
  
        // Email
        if (
          email.trim() === "" ||
          !regexEmail.test(email) ||
          email.includes("@gmail.com") ||
          email.includes("@outlook.com") ||
          email.includes("@hotmail.com") ||
          email.includes("@yahoo.com")
        ) {
          setEmailError(true);
          isValid = false;
        }
      } else if (section === "hero") {
        // Email
        if (
          email.trim() === "" ||
          !regexEmail.test(email) ||
          email.includes("@gmail.com") ||
          email.includes("@outlook.com") ||
          email.includes("@hotmail.com") ||
          email.includes("@yahoo.com")
        ) {
          setHeroEmailError(true);
          isValid = false;
        }
      }
  
      // If not valid, exit early
      if (!isValid) return;
  
      // Prepare data object
      let data = { email };
      if (section === "form") {
        data.name = name;
        data.phone = phone;
      }
  
      // Submit to API
      await axios.post(
        `${process.env.REACT_APP_SERVER_URI}/api/emailForNewsLetter`,
        data
      );
  
      // Open Calendly after successful submission
      window.open("https://calendly.com/goodlives/30min", "_blank");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: err.response?.data?.error || "Something went wrong!",
      });
    }
  };  

  const currentFeedback = feedbackData[currentIndex];
  return (
    <div className="app-container">
      {/* Header Section */}
      <header className="header-section">
        <div className="header-content">
          <div className="logo">
            <img src="https://ucarecdn.com/4748640f-b537-4b9b-8896-362944eaaae3/headerbookinglogo.png" alt="Company Logo" />
          </div>
          <nav className="nav-links">
            <a href="/">Home</a>
            <div className="dropdown-container">
              {/* <button onClick={toggleCorporateDropdown} className="dropdown-button">
                For Corporates 
              </button> */}
              <a href='/overall-wellness'>For Corporates</a>
              {isCorporateDropdownOpen && (
                <ul className="dropdown-menu">
                  <li><a href="#overall-wellness">Overall Wellness</a></li>
                  <li><a href="#employee-engagement">Employee Engagement</a></li>
                  <li><a href="#pulse-check-in">Pulse Check-In</a></li>
                  <li><a href="#predict-burnout">Predict Burnout</a></li>
                </ul>
              )}
            </div>
          </nav>
          <div className="auth-buttons">
            {/* <button className="login-button">Login</button>
            <button className="signup-button">Sign Up</button> */}
          </div>
        </div>
      </header>

      <div  className='hero-partner-section'> 
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-text-content">
            <h1 className='hero-heading'>Build Future-Ready Teams Through Expert-Led Learning</h1>
            <p className="hero-paragraph">{`Interactive trainings in leadership, communication,\nproductivity, and more — led by certified experts,\ntailored to your team’s real-world challenges`}</p>
            <div className="hero-cta-group">
                 <div className="email-input-wrapper">
                    <input
                      type="email"
                      placeholder="Enter your work email"
                      className={`hero-email-input ${heroEmailError ? 'input-error' : ''}`}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {/* {heroEmailError && ( */}
                      <label 
                        className="error-label"
                        style={{ visibility: heroEmailError ? 'visible' : 'hidden' }}
                      >
                        Please enter a valid work email
                      </label>
                    {/* )} */}
                  </div>
                  <button className="cta-button" onClick={(e) => scheduleDemo(e, 'hero')}>
                    Book a Demo
                  </button>
                </div>
          </div>
          <div className="hero-image-content">
            <img src="https://ucarecdn.com/127ba475-8cf1-4996-b187-5612a220d576/demopageheroimg.png" alt="Team Learning" />
          </div>
        </section>

        {/* Partners Section */}
        <section className="partners-section">
          <p className="partners-section-heading">Trusted by</p>
            <div className="partners-logos-container">
              <div className="partners-logos-scroll">
                {[...partnerLogos, ...partnerLogos].map((logo, index) => (
                  <img key={index} src={logo.src} alt={logo.alt} />
                ))}
              </div>
            </div>
        </section>
      </div>

      {/* Transform Section */}
      <section className="transform-section">
      <h2>We Don't Just Train. We Transform.</h2>
      <div className="transform-cards">
        <div className="transform-card">
          <div className="icon">
            <img className="transform-brain-icons" src='https://ucarecdn.com/773d4beb-bc3c-4cab-96a5-08efb65fc01d/brain.svg' alt='brain'/>
          </div>
          <h3>Expert-Led</h3>
        </div>
        <div className="transform-card">
          <div className="icon">
            <img className="transform-icons" src='https://ucarecdn.com/3d2c7429-3f95-43bb-bcc0-86e534dadefd/goal.svg' alt='target'/>
          </div>
          <h3>Custom-Tailored</h3>
        </div>
        <div className="transform-card">
          <div className="icon">
            <img className="transform-icons" src='https://ucarecdn.com/8e8507ec-c006-4722-9c52-2a8568073507/chart.svg' alt='chart'/>
          </div>
          <h3>Measurable Results</h3>
        </div>
      </div>
      </section>
      
      {/* What We Offer Section */}
      <div className="offers-wrapper">
        <p className="impact-heading" style={{marginBottom: "0px"}}>What We Offer</p>
        <div className='rowView'>
      <div className="offers-sidebar">
        {offers.map((offer, index) => (
          <div
            key={index}
            className={`sidebar-img-button ${index === selectedIndex ? 'active' : ''}`}
            style={{
              backgroundColor: index === selectedIndex ? offer.bgColor : '#FFFCF8', // Pink color for inactive
              boxShadow: index !== selectedIndex ? '0px 4px 8px rgba(0, 0, 0, 0.1)' : 'none', // Box shadow for inactive
            }}
            onClick={() => setSelectedIndex(index)}
          >
            <img src={offer.imglink} alt={`offer-${index}`} className='offer-icon'/>
          </div>
        ))}
      </div>

      <div className='columnView'>
      <div
        className="offer-details-card"
        style={{ backgroundColor: selectedOffer.bgColor }}
      >
        <div className="card-header">
          <img src={selectedOffer.imglink} alt="icon" className="card-icon" />
          <div>
            <p className='offerCard-title'>{selectedOffer.title}</p>
            <p className='offerCard-subtitle'>{selectedOffer.description}</p>
          </div>
        </div>

        <ul className="card-items">
          {selectedOffer.items.map((item, idx) => (
            <li key={idx} className='offerCard-list'>{item}</li>
          ))}
        </ul>

        <p className="more-text">& many more</p>
      </div>
      <button className="offer-grid-button"onClick={(e) => {e.stopPropagation(); window.open("https://calendly.com/goodlives/30min", "_blank");}}>Book a Demo</button>
      </div>
      </div>
      <button className="trainers-grid-button1"onClick={(e) => {e.stopPropagation(); window.open("https://calendly.com/goodlives/30min", "_blank");}}>Book a Demo</button>
    </div>
    

      {/* About Our Trainers Section */}
      <section className="trainers-main-section">
        <h2 className="trainers-heading">About Our Trainers</h2>
        <div className="trainers-grid">
          {isMobile ? (
            <>
            {[...cardData, ...cardData].map((text, i) => (
            <div className="trainer-card" key={`mobile-trainer-${i}`}>
              <div className="feature-icon-circle">
                <img
                  src={traningCardLogo[i % traningCardLogo.length].src}
                  alt={traningCardLogo[i % traningCardLogo.length].alt}
                  className="feature-icon"
                />
              </div>
              <p className="trainer-description">{text}</p>
            </div>
          ))}
            </>
        ) : (
          <>
          {cardData.map((text, i) => (
            <div className="trainer-card" key={i}>
              <div className="feature-icon-circle">
                <img src={traningCardLogo[i].src} alt={traningCardLogo[i].alt} className="feature-icon" />
              </div>
              <p className="trainer-description">{text}</p>
            </div>
          ))}
          </>
        )}
        </div>
    </section>
    <button className="trainers-grid-button"onClick={(e) => {e.stopPropagation(); window.open("https://calendly.com/goodlives/30min", "_blank");}}>Book a Demo</button>

      {/* Our Impact Section */}
      <section className="impact-main-section">
      <h2 className="impact-heading">Our Impact</h2>
      <div className="impact-stats-container">
        <div className="impact-stat-card">
          <div className="impact-circle">
            <img src="https://ucarecdn.com/3f755241-5bf0-4fde-af78-715be1be57aa/Vector.svg" alt="Growth Icon" className="impact-icon" />
            <p className="stat-value">85%</p>
          </div>
          <div className="stat-label-box">
            <p className="stat-label">improved team collaboration</p>
          </div>
        </div>

        <div className="impact-stat-card">
          <div className="impact-circle">
            <img src="https://ucarecdn.com/2aea2d14-2ceb-4cef-84b9-7c73c1f96a76/Icon.svg" alt="Star Icon" className="impact-icon" />
            <p className="stat-value">4.8/5</p>
          </div>
          <div className="stat-label-box">
            <p className="stat-label">average training rating</p>
          </div>
        </div>

        <div className="impact-stat-card">
          <div className="impact-circle">
            <img src="https://ucarecdn.com/c66acdd3-785c-4997-87d4-26015011a732/Send.svg" alt="Rocket Icon" className="impact-icon" />
            <p className="stat-value">90%</p>
          </div>
          <div className="stat-label-box">
            <p className="stat-label">of learners apply key insights within 1 week</p>
          </div>
        </div>
      </div>
    </section>

      {/* Real Stories, Real Impact Section */}
      <section className="stories-main-section">
      <h2 className="stories-heading">Real Stories, Real Impact</h2>
      <p className="stories-subheading">See How Companies Are Building Stronger Teams</p>

      <div className="feedback-carousel-container">
        <button className="carousel-button prev-button" onClick={handlePrev}>
          &lt;
        </button>

        <div className="feedback-card-wrapper">
          <div className="feedback-header">
            <img src={currentFeedback.avatar} alt={currentFeedback.name} className="feedback-avatar" />
            <div className="feedback-info">
              <h3 className="feedback-name">{currentFeedback.name}</h3>
              <p className="feedback-title">{currentFeedback.title}</p>
            </div>
          </div>
          <div className="feedback-text-container">
            <p className="feedback-quote">"{currentFeedback.feedbackText}"</p>
          </div>
        </div>

        <button className="carousel-button next-button" onClick={handleNext}>
          &gt;
        </button>
      </div>

      <div className="pagination-dots">
        {feedbackData.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </section>

      {/* GoodLives in the news Section */}
      <section className="news-section">
        <p className="stories-heading">GoodLives in the news</p>
        <div className="news-logos">
          <img src="https://ucarecdn.com/90e0284c-99ab-4b87-be6b-fae54b487d7c/image2831.svg" alt="Inc Logo" />
          <img src="https://ucarecdn.com/2f42efbc-a999-407b-9e1a-fbcb47b26100/image2824.svg" alt="Wire Logo" />
          <img src="https://ucarecdn.com/5063c46f-70d1-40c1-96db-40235613eb25/image2833.svg" alt="Forbes Logo" />
          <img src="https://ucarecdn.com/93454667-0e43-4233-900c-87205fe7f262/image2834.svg" alt="TechCrunch Logo" />
          <img src="https://ucarecdn.com/bbe4f5f1-9b18-4f10-9c97-bbd403905ef4/image2821.svg" alt="India Today Logo" />
          <img src="https://ucarecdn.com/e6569e8b-0a46-4270-9076-cef3232fdf7b/image2832.svg" alt="Hindustan Logo" className='hindustan-logo-custom'/>
        </div>
      </section>

      {/* Get in touch Section */}
      <section className="contact-main-section">
      <div className="contact-container">        
        <h2 className="stories-heading">Get in touch</h2>
        <div className='contact-container-row'>
        <div className="contact-image-wrapper">
          <img 
            src="https://ucarecdn.com/2c5d3b79-63c7-4b9a-ac3f-f80c31dee8ab/21493007281.svg"
            alt="People in a meeting" 
            className="contact-illustration" 
          />
        </div>

        <form className="contact-form">
          <input type="text" placeholder="Name*" className={`form-input ${nameError ? 'input-error' : ''}`} onChange={(e) => {
                  setName(e.target.value);
                  if (nameError) setNameError(false);
          }}/>
          {nameError && <label className="error-label">Please enter your name</label>}
          <input type="email" placeholder="Work Email*" className={`form-input ${emailError ? 'input-error' : ''}`} onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailError) setEmailError(false);
          }}/>
          {emailError && <label className="error-label">Please enter a valid work email</label>}
          <input type="tel" maxLength={14} placeholder="Mobile No.*" className={`form-input ${phoneError ? 'input-error' : ''}`} onChange={(e) => {
                  setPhone(e.target.value);
                  if (phoneError) setPhoneError(false);
          }}/>
          {phoneError && <label className="error-label">Please enter a valid 9 to 11-digit mobile number</label>}
          <button type="submit" className="book-demo-button"onClick={(e) => scheduleDemo(e, 'form')}>Book a Demo Now</button>
        </form>
        </div>
      </div>
    </section>

      {/* Footer Section */}
      <NewFooter/>
    </div>
  );
};

export default DemoPage;
